<template>
  <base-modal
    :close-button-visible="false"
    overlay-class="other_modals please_wait no_close"
    modal-content-class="modal_glow"
  >
    <base-loader></base-loader>
  </base-modal>
</template>

<script>
import BaseModal from './BaseModal'
import BaseLoader from '../loader/BaseLoader'

export default {
  name: 'BaseLoaderModal',
  components: {
    BaseModal,
    BaseLoader
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/modal/BaseLoaderModal.vue